var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.vtnRequest
    ? _c(
        "div",
        [
          _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c("app-header-dados-processo", {
                attrs: {
                  processo: _vm.processo,
                  isCCR: false,
                  dadosCadastros: _vm.dadosCadastros
                }
              })
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "card-container", attrs: { shadow: "hover" } },
            [
              _c(
                "div",
                [
                  _c(
                    "el-steps",
                    {
                      staticClass: "card-container",
                      attrs: {
                        active: _vm.active,
                        "finish-status": "success",
                        simple: "simple"
                      }
                    },
                    [
                      _c("el-step", { attrs: { title: "Dados do VTN" } }),
                      _c("el-step", { attrs: { title: "Confirmar dados VTN" } })
                    ],
                    1
                  ),
                  _vm.active === 0
                    ? _c(
                        "validation-observer",
                        { ref: "validation", attrs: { tag: "div" } },
                        [
                          _vm.active === 0
                            ? _c(
                                "div",
                                [
                                  _c("app-radios-tramitacao", {
                                    attrs: {
                                      radios: _vm.acaoEmissaoVtn,
                                      isDecisao: true,
                                      radioInicial: _vm.action
                                    },
                                    on: { changeRadio: _vm.changeRadioDespacho }
                                  }),
                                  _vm.vtnRequest && !_vm.isDespacho
                                    ? _c("informar-dados-ma", {
                                        attrs: {
                                          vtnRequest: _vm.vtnRequest,
                                          tipoProcesso: this.processo.tipo
                                            .codigo
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm.active === 1 && !_vm.isDespacho
                    ? _c(
                        "div",
                        [
                          _c("ConfirmarDados", {
                            attrs: {
                              dadosVtn: _vm.calculado,
                              tipoProcesso: this.processo.tipo.codigo
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isDespacho
                    ? _c(
                        "div",
                        [
                          _vm.isArquivamentoIndeferimento &&
                          !_vm.isReurbIndividual
                            ? _c(
                                "el-card",
                                [
                                  _c("app-label", {
                                    attrs: {
                                      label:
                                        "Inclua a Carta de Notificação ao Interessado",
                                      required: _vm.isValidateCarta !== ""
                                    }
                                  }),
                                  _c("validation-provider", {
                                    attrs: { rules: _vm.isValidateCarta },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-anexo", {
                                                attrs: {
                                                  id:
                                                    "upload-carta-notificacao",
                                                  files: _vm.cartas,
                                                  showAnexar: true,
                                                  errors: errors,
                                                  tiposArquivosPermitidos:
                                                    _vm.tiposArquivosPermitidosMapas,
                                                  showUpload:
                                                    _vm.cartas.length === 0
                                                },
                                                on: {
                                                  uploadFile:
                                                    _vm.uploadCartaNotificacao,
                                                  removeFile:
                                                    _vm.removeCartaNotificacao,
                                                  downloadDocumentoCadastro:
                                                    _vm.getDownload
                                                },
                                                model: {
                                                  value: _vm.cartas,
                                                  callback: function($$v) {
                                                    _vm.cartas = $$v
                                                  },
                                                  expression: "cartas"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      87136372
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        staticClass: "input-text-editor",
                                        attrs: { label: "Despacho" }
                                      }),
                                      _c("app-editor-texto", {
                                        ref: "editorTexto",
                                        staticClass: "input",
                                        class: { erro: errors.length },
                                        on: { onTextChange: _vm.onTextChange },
                                        model: {
                                          value: _vm.despacho.textoDespacho,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.despacho,
                                              "textoDespacho",
                                              $$v
                                            )
                                          },
                                          expression: "despacho.textoDespacho"
                                        }
                                      }),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2877039618
                            )
                          }),
                          _c("app-anexo", {
                            attrs: {
                              id: "upload-anexo-despacho",
                              files: _vm.despacho.documentos,
                              tipoExibir: "ANEXO_ANALISE"
                            },
                            on: {
                              uploadFile: _vm.uploadFile,
                              removeFile: _vm.removeFile,
                              downloadDocumentoCadastro:
                                _vm.downloadDocumentoCadastro
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.active === 1 || _vm.isDespacho
                    ? _c(
                        "validation-observer",
                        { ref: "validation2", attrs: { tag: "div" } },
                        [
                          _c("app-radios-tramitacao", {
                            attrs: { isDecisao: false, radios: _vm.getAcoes },
                            on: { changeRadio: _vm.changeRadio }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("app-buttons-cadastro", {
                    attrs: {
                      showButtonCancelar: true,
                      showButtonSalvar: true,
                      showButtonProximo: !_vm.isUltimoPasso,
                      isUltimoPasso: _vm.isUltimoPasso,
                      isPrimeiroPasso: _vm.isPrimeiroPasso
                    },
                    on: {
                      proximo: _vm.proximo,
                      voltar: _vm.voltar,
                      cancelar: _vm.cancelar,
                      salvar: _vm.salvar,
                      finalizar: _vm.finalizar
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20a74889", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20a74889","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/CadastrarVtnMA.vue
// module id = null
// module chunks = 